// Copyright © 2026 ApexRuntime Labs by Shashi (https://github.com/spshah). All rights reserved.

import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext';
import { OfflineProvider } from './offline/connectivity';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import LoginPage from './pages/auth/Login';
import SignUpPage from './pages/auth/SignUp'; // ← fixed
import SignOutPage from './pages/auth/SignOut';
import UpdatePasswordPage from './pages/auth/UpdatePassword';
import ErrorPage from './pages/Error';
import ProtectedRoute from './components/ProtectedRoute';
import { AppDashboard } from './pages/Apps';
import { BudgetRoutes } from './pages/budget/BudgetRoutes';
import CategoriesPage from './pages/Categories';
import BudgetPeriods from './pages/BudgetPeriods';
import PaymentMethods from './pages/PaymentMethods';
import ProfilePage from './pages/Profile';
import { BudgetFeedRoutes } from './pages/budgetfeed/home';
import Security from './pages/security/home';
import Admin from './pages/admin/home';
import './styles/css/index.css';
import { AppLayout } from './components/layout';

const router = createBrowserRouter([
  {
    path: '/',
    element: <LoginPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/signup',
    element: <SignUpPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/logout',
    element: <SignOutPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/updatepassword',
    element: <UpdatePasswordPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/apps/',
    element: (
      <ProtectedRoute>
        <AppLayout /> {/* ← provides sidebar + topnav + <Outlet> */}
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <AppDashboard />,
      },
      {
        path: 'budget/*',
        element: <BudgetRoutes />,
      },
      {
        path: 'categories',
        element: <CategoriesPage />,
      },
      {
        path: 'budget-periods',
        element: <BudgetPeriods />,
      },
      {
        path: 'payment-methods',
        element: <PaymentMethods />,
      },
      {
        path: 'budgetfeed/*',
        element: <BudgetFeedRoutes />,
      },
      {
        path: 'profile',
        element: <ProfilePage />,
      },
      {
        path: 'security',
        element: <Security />,
      },
      {
        path: 'admin',
        element: <Admin />,
      },
    ],
    errorElement: <ErrorPage />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <OfflineProvider>
        <RouterProvider router={router} />
      </OfflineProvider>
    </AuthProvider>
  </React.StrictMode>,
);

if (process.env.NODE_ENV === 'production') {
  serviceWorkerRegistration.register();
} else {
  serviceWorkerRegistration.unregister();
}
reportWebVitals();
